import store from '../store';
// src/middleware/auth.js
export default function auth({ next, router }) {
  if (!localStorage.getItem('token')) {
      localStorage.removeItem("token");
      store.commit("vaciarDatosSession");
      return router.push("/Login");
  } else {
    const jwtPayload = parseJwt(localStorage.getItem('token'));
    // Verificación de vigencia de token
    if (jwtPayload.exp < Date.now()/1000) {
        // token expirado
        localStorage.removeItem("token");
        store.commit("vaciarDatosSession");
        return next("/Login");
    }
    return next();
  }
}

function parseJwt (token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(Buffer.from(base64, "base64").toString("ascii").split("").map((c) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};